import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseCard, RCard} from './cardModel';

const RSeenDirty = t.readonly(
  t.type({
    seenAt: t.Integer,
    card: t.union([RCard, t.undefined]),
  }),
);

const RSeensDirty = t.readonly(
  t.type({
    messageUid: t.string,
    seens: t.readonlyArray(RSeenDirty),
  }),
);

/*
 * Type.
 */

export interface SeenModel extends t.TypeOf<typeof RSeenDirty> {}
export interface SeensModel extends t.TypeOf<typeof RSeensDirty> {}
export const RSeen = t.clean<SeenModel>(RSeenDirty as any);
export const RSeens = t.clean<SeensModel>(RSeensDirty as any);

/*
 * IO methods.
 */

export function parseSeen(src: any): SeenModel {
  return {
    seenAt: src.seen_at,
    card: src.contact?.card ? parseCard(src.contact.card) : undefined,
  };
}

export function parseSeens(src: any): SeensModel {
  return {
    messageUid: src.message.uid,
    seens: Array.isArray(src.seens) ? src.seens.map(parseSeen) : [],
  };
}

/*
 * API type.
 */

export const ApiSeens = makeApiType('seens', RSeens, parseSeens);
